module.exports = "\n    <router-outlet></router-outlet>\n    <ngx-ui-loader></ngx-ui-loader>\n\n"